enum selectSizeEnum {
	big = 'big',
	small = 'small'
}

export default selectSizeEnum